<template>
  <div>
    <v-container v-if="saleMemberInfo[0]">
      <v-card>
        <v-card-title primary-title>
          <div>
            <div class="display-1">基金经理：{{ saleMemberInfo[0].name }}</div>
            <img class="avatar" :src="`/cannan_api/images/${saleMemberInfo[0].avatar}`" :alt="saleMemberInfo[0].avatar">
          </div>
        </v-card-title>
      </v-card>
    </v-container>
    <v-data-table :headers="headers" :items="saleMemberInfo" class="elevation-1">
      <template slot="items" slot-scope="props">
        <td class="text-xs-center">{{ props.item.code }}</td>
        <td class="text-xs-center">
          <router-link :to="`/sale/${props.item.sale_id}`">
            {{ props.item.title }}
          </router-link>
        </td>
        <td class="text-xs-center">{{ props.item.type }}</td>
        <td class="text-xs-center">{{ props.item.start_date }}</td>
        <td class="text-xs-center">{{ props.item.end_date }}</td>
        <td class="text-xs-center">{{ props.item.work_date }}</td>
        <td class="text-xs-center">{{ props.item.work_request }}</td>
        <td class="text-xs-center">
          <router-link :to="`/saleCompany/${props.item.company_id}`">
            {{ props.item.company_title }}
          </router-link>
        </td>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  data() {
    return {
      // table
      headers: [
        { text: '基金代码', align: 'center', value: 'code' },
        { text: '基金名称', align: 'center', value: 'title' },
        { text: '基金类型', align: 'center', value: 'type' },
        { text: '起始时间', align: 'center', value: 'start_date' },
        { text: '截止时间', align: 'center', value: 'end_date' },
        { text: '任职时间', align: 'center', value: 'work_date' },
        { text: '任职回报', align: 'center', value: 'work_request' },
        { text: '机构名称', align: 'center', value: 'company_title' }
      ],
      route_id: this.$route.params && this.$route.params.id,
      device: 'desktop'
    }
  },
  computed: mapGetters({
    saleMemberInfo: 'saleMemberInfo'
  }),
  created() {
    this.fetchData()

    if (
      navigator.userAgent.indexOf('iPhone') > -1 ||
      navigator.userAgent.indexOf('Android') > -1
    ) {
      this.device = 'mobile'
    } else {
      this.device = 'desktop'
    }
  },
  methods: {
    fetchData() {
      this.$store.dispatch('GetSaleMemberInfo', this.route_id)
    }
  }
}
</script>
